import { type PaletteOptions } from '@mui/material/styles'

import { customPalette } from '@Material/customPalette'

const darkTheme: PaletteOptions = {
  primary: {
    main: '#00C0F2', // Figma: Primary
    contrastText: '#0D0E13', // Figma: OnPrimary
    dark: '#009DD0', // Figma: PrimaryDark
  },
  secondary: {
    main: '#FFAF5E', // Figma: Secondary
    contrastText: '#0D0E13', // Figma: OnSecondary
    dark: '#FF8C17', // Figma: PrimaryDark
  },
  text: {
    primary: '#F3F3F4', // Figma: OnBackground et OnSurface
    secondary: '#9DA0A5', // Figma: Text Secondary
    disabled: '#506876', // Figma: Disabled
  },
  success: {
    main: '#6BDB64', // Figma: Success
  },
  warning: {
    main: '#ED8744', // Figma: Warning
  },
  error: {
    main: '#CD0037', // Figma: Error
    dark: '#A6093D', // Figma: Error hover
  },
  action: {
    active: '#F3F3F4', // Figma: not yet defined
    disabled: '#506876', // Figma: Disabled
    disabledBackground: undefined,
  },
  // TODO https://jira.vsct.fr/browse/SIBR-1794 supprimer lors de la migration vers MUI v6
  background: customPalette(true).customPalette?.background,
}

const lightTheme: PaletteOptions = {
  primary: {
    main: '#225490', // Figma: Primary
    dark: '#013B5D', // Figma: PrimaryDark
    contrastText: '#FDFCFE', // Figma: OnPrimary
  },
  secondary: {
    main: '#FF7F00', // Figma: Secondary
    dark: '#E47B08', // Figma: SecondaryDark
    contrastText: '#0D0E13', // Figma: OnSecondary
  },
  text: {
    primary: '#0D0E13', // Figma: OnBackground et OnSurface
    secondary: '#494E57', // Figma: Text Secondary
    disabled: '#D4D4D4', // Figma: Disabled
  },
  success: {
    main: '#007C33', // Figma: Success
  },
  warning: {
    main: '#AE4713', // Figma: Warning
  },
  error: {
    main: '#CD0037', // Figma: Error
    dark: '#A6093D', // Figma: Error hover
  },
  action: {
    active: '#0D0E13', // Figma: not yet defined
    disabled: '#D4D4D4', // Figma: Disabled
    disabledBackground: undefined,
  },
  // TODO https://jira.vsct.fr/browse/SIBR-1794 supprimer lors de la migration vers MUI v6
  background: customPalette(false).customPalette?.background,
}

export const palette = (prefersDarkMode: boolean): PaletteOptions =>
  prefersDarkMode
    ? {
        mode: 'dark',
        ...darkTheme,
      }
    : {
        mode: 'light',
        ...lightTheme,
      }
